import React, { useEffect } from 'react';
import { Container, Button, Typography, Backdrop, CircularProgress} from '@mui/material';
import Header from '../components/layout/Header';
import DonateurInfoSection from '../components/sections/DonateurInfoSection';
import RecapSection from '../components/sections/RecapSection';
import { useParams } from 'react-router-dom';
import InscriptionForm from '../components/forms/Inscription';

export const InscriptionContext = React.createContext();
const Inscription = () => {
    const { id } = useParams()
    const [load, setLoad] = React.useState(true);
    const [event, setEvent] = React.useState('');
    const [checkoutId, setCheckoutId] = React.useState(null);

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/public/project/${id}`, { method: 'GET' })
        .then(response => response.json())
        .then(data => {
            setEvent(data);
            setLoad(false);
        })
        .catch(error => console.error('Error fetching event:', error));
    }, [id]);
  
  return (
    <>
        <Header />
        <InscriptionContext.Provider value={{setCheckoutId}}>
            <Container maxWidth="sm" sx={{ mt: 4, minWidth:'500px' }}>
                <Typography variant='h2'>Inscription à l'évènement<br/>{event?.titre}</Typography>
                <Typography variant="body1" gutterBottom>Organisé par {event.organisateur}</Typography>
                <InscriptionForm {...{event, setLoad}} />
            </Container>
        </InscriptionContext.Provider>
        <Backdrop open={load}><CircularProgress/></Backdrop>
    </>
  );
};

export default Inscription;